import React from 'react';
import { Container } from './Container';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  id?: string;
  background?: 'white' | 'offwhite' | 'sand' | 'deep-blue';
}
export function Section({
  children,
  className = '',
  containerClassName = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    offwhite: 'bg-neutral-offwhite',
    sand: 'bg-neutral-sand',
    'deep-blue': 'bg-primary-deep-blue text-white'
  };
  return <section id={id} className={`py-16 ${bgColors[background]} ${className}`} data-id="element-238">
      <Container className={containerClassName} data-id="element-239">{children}</Container>
    </section>;
}